export class TaskContract {
  currencyCode: string;
  contractedAmount: number;
  measuredValue: number;
  percentageMeasuredUnderContracted: number;
  amountPaid: number;
  amountReleased: number;
  balanceToPay: number;
  percentagePaidUnderReleased: number;
  percentageReleasedUnderMeasured: number;
}
